import { cn } from '@rocco/utils/cn';
import { FilterPillIcon } from '~/ui-rocco/pages/directory-browse/DirectoryPillBar';
import { ProfessionalTabSearchField } from './ProfessionalTabSearchField';

interface ProfessionalTabListingBarProps {
    search: {
        value: string;
        onChange: (value: string) => void;
        placeholder: string;
        ariaLabel?: string;
    };
    /**
     * Opens the tab's filter sheet. Left off, the control still stands —
     * every listing tab opens on the same bar — but disabled, until the tab
     * has filters of its own (by the professional / tagged in, say).
     */
    onOpenFilters?: () => void;
    /** Applied filters, shown on the filter control's corner. */
    filtersCount?: number;
    className?: string;
}

/**
 * The phone's bar under the tabs on every listing tab — Products, Projects,
 * Articles, Videos, Network, Downloads: the product directory's filter
 * control with its search field open beside it, full width. Below md only;
 * the tabs keep their own desktop rows.
 */
export const ProfessionalTabListingBar = ({
    search,
    onOpenFilters,
    filtersCount = 0,
    className,
}: ProfessionalTabListingBarProps) => (
    <div className={cn('flex items-center gap-3 md:hidden', className)}>
        <button
            type="button"
            onClick={onOpenFilters}
            disabled={!onOpenFilters}
            aria-label="Refine"
            className="relative flex size-11 shrink-0 items-center justify-center rounded-[1rem] bg-[#323232] text-white transition-colors active:bg-[#515151] disabled:opacity-40"
        >
            <FilterPillIcon />
            {filtersCount > 0 ? (
                <span className="absolute -top-0.5 -right-0.5 flex size-5 items-center justify-center rounded-full bg-white text-[0.6875rem] font-medium text-[#323232]">
                    {filtersCount}
                </span>
            ) : null}
        </button>
        <ProfessionalTabSearchField
            value={search.value}
            onChange={search.onChange}
            placeholder={search.placeholder}
            ariaLabel={search.ariaLabel}
            className="min-w-0 flex-1"
        />
    </div>
);
